import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

import adminList from '@/pages/admin/adminList' //管理员列表
import adminDetail from '@/pages/admin/adminDetail' //管理员详情
import userList from '@/pages/user/userList' //用户列表
import advList from '@/pages/adv/advList' //首页广告轮播图
import config from '@/pages/config' //系统设置
import index from '@/pages/index' //首页
import login from '@/pages/login' //登录

import goods from './module/goods.js' //商品管理
import saleGoods from './module/saleGoods.js' //天天特价管理
import order from './module/order.js'  //订单管理
import door from './module/door.js' //门店管理
import member from './module/member.js' //会员管理
import recharge from './module/recharge.js' //充值管理
import coupon from './module/coupon.js' //优惠券管理
import integral from './module/integral.js' //积分管理
import cityinfo from './module/cityinfo.js' //同城信息管理


const vueRouter = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
		...goods,
	  ...saleGoods,
	  ...order,
		...door,
		...member,
		...recharge,
		...coupon,
		...integral,
		...cityinfo,
		{
      path: '/',
      name: 'index',
      meta: {
        title: '首页'
      },
      component: index
    },
    {
      path: '/login',
      name: 'login',
			meta: {
        title: '登录'
      },
      component: login
    },
		{
		  path: '/config',
		  name: 'config',
			meta: {
		    title: '系统设置'
		  },
		  component: config
		},
		{
		  path: '/userList',
		  name: 'userList',
			meta: {
		    title: '用户列表'
		  },
		  component: userList
		},
		{
		  path: '/adminList',
		  name: 'adminList',
			meta: {
		    title: '管理员列表'
		  },
		  component: adminList
		},
		{
		  path: '/adminDetail',
		  name: 'adminDetail',
			meta: {
		    title: '管理员详情'
		  },
		  component: adminDetail
		},
		{
		  path: '/advList',
		  name: 'advList',
			meta: {
		    title: '首页广告轮播图'
		  },
		  component: advList
		}
		
  ],
})

export default vueRouter
